import { rtdb } from "../../firebase";
import { ref, onValue, onDisconnect, set, push, remove } from "firebase/database";
import { emailKey, normEmail } from "../../util/email";
import {
  PRESENCE_LISTEN_REQUEST, PRESENCE_LISTEN_SUCCESS, PRESENCE_LISTEN_FAILURE,
  PRESENCE_SET_REQUEST, PRESENCE_SET_SUCCESS, PRESENCE_SET_FAILURE
} from "./PresenceTypes";

export const setMyPresence = ({ email, displayName }) => async (dispatch) => {
  try {
    dispatch({ type: PRESENCE_SET_REQUEST });
    const key = emailKey(email);
    const emailLC = normEmail(email);
    const sessionRef = push(ref(rtdb, `presenceSessions/${key}`));
    await set(sessionRef, true);
    onDisconnect(sessionRef).remove();

    const nodeRef = ref(rtdb, `presence/${key}`);
    await set(nodeRef, { email: emailLC, displayName: displayName || null, online: true, lastSeen: Date.now() })
    
    onDisconnect(nodeRef).set({ email: emailLC, displayName: displayName || null, online: false, lastSeen: Date.now() });

    dispatch({ type: PRESENCE_SET_SUCCESS });
    // Return a cleanup that removes session on manual unmount (optional)
    return () => remove(sessionRef).catch(()=>{});
  } catch (err) {
    dispatch({ type: PRESENCE_SET_FAILURE, payload: err.message });
  }
};

export const listenToPresence = () => (dispatch) => {
  dispatch({ type: PRESENCE_LISTEN_REQUEST });
  try {
    const listRef = ref(rtdb, `presence`);
    const unsub = onValue(listRef, (snap) => {
      const val = snap.val() || {};
      dispatch({ type: PRESENCE_LISTEN_SUCCESS, payload: Object.values(val) });
    }, (err) => dispatch({ type: PRESENCE_LISTEN_FAILURE, payload: err.message }));
    return () => unsub();
  } catch (err) {
    dispatch({ type: PRESENCE_LISTEN_FAILURE, payload: err.message });
  }
};

